const professionalButton = document.querySelector('.js-professional-button');
const particulierButton = document.querySelector('.js-particulier-button');

if(professionalButton) {
    professionalButton.addEventListener('click', function() {
        updateLocalStorage('b2b');
    });
}

if(particulierButton) {
    particulierButton.addEventListener('click', function() {
        updateLocalStorage('b2c');
    });
}

function updateLocalStorage(userType) {
    const existingUserType = localStorage.getItem('user_type');
    if (existingUserType && existingUserType !== userType) {
        localStorage.setItem('user_type', userType);
    } else if (!existingUserType) {
        localStorage.setItem('user_type', userType);
    }
}

var customerType = localStorage.getItem('user_type');

// FIX: Butonlar varsa göster/gizle
if(professionalButton && particulierButton) {
    if(customerType === 'b2b') {
        professionalButton.style.display = 'none';
        professionalButton.style.opacity = 0;
        professionalButton.style.visibility = 'hidden';
        particulierButton.style.display = 'inline-flex';
        particulierButton.style.opacity = 1;
        particulierButton.style.visibility = 'visible';
    } else {
        professionalButton.style.display = 'inline-flex';
        professionalButton.style.opacity = 1;
        professionalButton.style.visibility = 'visible';
        particulierButton.style.display = 'none';
        particulierButton.style.opacity = 0;
        particulierButton.style.visibility = 'hidden';
    }
}
